module.exports = __webpack_public_path__ + "assets/img/home.7933a2da.png";